// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartHistoryType } from '@front/chart/TerceraChartUtils';
import { TradingToolViewBase } from '@front/chart/Tools/TradingTools/TradingToolViewBase';
import { TerceraChartTradingOperation } from '@front/chart/Utils/ChartConstants';
import { AlertCondition, AlertImportance } from '../Alert/AlertConstants';
import { AlertUtils } from '../Alert/AlertUtils';
import { TradingViewBaseTool } from './TradingViewBaseTool';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
export class TradingViewAlertTool extends TradingViewBaseTool {
    constructor() {
        super();
    }
    getType() {
        return 'TradingViewAlertTool';
    }
    getPrice() {
        const alert = this.get('dataObject');
        return alert ? alert.Value : null;
    }
    id() {
        const alert = this.get('dataObject');
        return alert ? alert.AlertId : null;
    }
    oninit() {
        super.oninit();
        this.observe('dataObject dragging hovered', this.updateToolImage);
        this.observe('dragging', (v) => {
            void this.set('mainCursor', v ? 'grabbing' : 'grab');
        });
        this.on('handleActionImageClick', (e) => {
            this.onEditOrCloseClick();
        });
        this.on('handleCancelImageClick', (e) => {
            this.onEditOrCloseClick(true);
        });
        this.on('dragend', this.onMoveAlertToolFinished);
    }
    onEditOrCloseClick(isCloseClick = false) {
        const updateData = { action: TerceraChartTradingOperation[isCloseClick ? 'RemoveAlert' : 'EditAlert'] }; // <- TODO EditAlert Will not work after master merge!!! EditAlert updated in ver.111: https://gerrit.traderevolution.com/c/NodeWeb/+/90907/1/client/scripts/Utils/Trading/ChartTradingCore.ts#168
        const alert = this.get('dataObject');
        const chartTradingCore = this.get('chartTradingCoreRef');
        if (chartTradingCore && alert) {
            chartTradingCore.ChartVisualTrading(alert, updateData);
        }
    }
    updateToolImage() {
        const alert = this.get('dataObject');
        if (!alert)
            return;
        const mainImgHovered = this.get('mainImageHovered');
        const actionButtonImgHovered = this.get('actionImageHovered');
        const cancelButtonImgHovered = this.get('cancelImageHovered');
        const mainImg = ThemeManager.NewImages.alertIconDefault.image;
        const actionButtonImg = ThemeManager.NewImages.alertEditDefault.image;
        const cancelButtonImg = ThemeManager.NewImages.closeIconDefault.image;
        let penLine = null;
        let backgroundPen = null;
        let backgroundBrush = null;
        if (this.get('dragging')) {
            penLine = TradingToolViewBase.chartOrderModifiedPen;
            backgroundPen = TradingToolViewBase.grayBackgroundPen;
            backgroundBrush = TradingToolViewBase.chartOrderModifiedBrush;
        }
        else if (alert.Importance === AlertImportance.HIGH) {
            // penLine = this.myRenderer.highAlertPricePen;
            // backgroundPen = TradingToolViewBase.highAlertBackgroundPen;
            backgroundBrush = TradingToolViewBase.highAlertBackgroundBrush;
        }
        else if (alert.Importance === AlertImportance.MEDIUM) {
            // penLine = this.myRenderer.mediumAlertPricePen;
            // backgroundPen = TradingToolViewBase.mediumAlertBackgroundPen;
            backgroundBrush = TradingToolViewBase.mediumAlertBackgroundBrush;
        }
        else if (alert.Importance === AlertImportance.LOW) {
            // penLine = this.myRenderer.lowAlertPricePen;
            // backgroundPen = TradingToolViewBase.lowAlertBackgroundPen;
            backgroundBrush = TradingToolViewBase.lowAlertBackgroundBrush;
        }
        void this.set({
            mainImg,
            actionImg: actionButtonImg,
            cancelImg: cancelButtonImg,
            mainSrc: mainImg.src,
            actionSrc: actionButtonImg.src,
            cancelSrc: cancelButtonImg.src,
            pricePlateColor: backgroundBrush.Color,
            priceLineColor: backgroundPen.Color
        });
    }
    onMoveAlertToolFinished() {
        var _a, _b;
        const ins = this.getInstrument();
        const priceValue = this.get('priceValue');
        const newPrice = ins !== null ? ins.roundPrice(priceValue) : priceValue;
        const ht = TerceraChartHistoryType.GetOriginalHistoryType((_b = (_a = this.toolsContainerRef) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.GetHistoryType(), ins);
        const valueFromInstrument = AlertUtils.GetCorrectPriceForAlertByInstrument(ins, ht);
        let condition = null;
        if (!isNaN(valueFromInstrument)) {
            condition = newPrice > valueFromInstrument ? AlertCondition.MORE_EQUAL : AlertCondition.LESS_EQUAL;
        }
        this.lastValidPriceValue = newPrice;
        const core = this.get('chartTradingCoreRef');
        if (core) {
            core.ChartVisualTrading(this.get('dataObject'), {
                Value: newPrice,
                Condition: condition,
                MoveChart: true,
                action: TerceraChartTradingOperation.AlertReplacement
            });
        }
    }
}
TradingViewBaseTool.extendWith(TradingViewAlertTool, {
    data: function () {
        return {
            className: 'tradingView-alert-tool',
            useTextForAction: false, // text description with quantity for Order, PnL for Position but image (useTextForAction=false) for action section in Alert tools
            mainCursor: 'grab', // 'ns-resize',
            actionCursor: 'pointer',
            closeCursor: 'pointer',
            height: 32
        };
    }
});
